import React, { useEffect, useState } from "react";
import LookupSearch from "./LookupSearch";
import LookupSelect from "./components/LookupSelect";
import { searchIndexes } from "../../../config/searchIndexes";
import _ from "lodash";
import LookupResultItem from "./components/LookupResultItem";
import { useNavigate } from "react-router-dom";
import { getCustomerOrders, searchCustomers, searchProducts } from "../../../config/searchApis";
import LookupDetails from "./LookupDetails";
import { RiArrowLeftCircleFill } from "react-icons/ri";
import LookupFilters from "./components/LookupFilters";

const Lookup = ({ setisLookup, isLookup }) => {
  const navigate = useNavigate();

  const [selected, setselected] = useState("Dashboard");
  const [filters, setfilters] = useState({});
  const [details, setdetails] = useState(null);
  const [searchQuery, setsearchQuery] = useState("");
  const [result, setresult] = useState([]);

  //   keyboard controls
  const [cursor, setcursor] = useState(0);

  useEffect(() => {
    if (searchQuery.length < 2) {
      const history =
        localStorage.getItem("searchHistory") && JSON.parse(localStorage.getItem("searchHistory"));
      if (history) {
        setresult([...history]);
      }
    }
  }, [searchQuery]);

  // set preselected filters
  useEffect(() => {
    if (selected === "Products") {
      setfilters({ draft: "all" });
    }
  }, [selected]);

  // search on filters change
  useEffect(() => {
    searchHandler(searchQuery);
  }, [filters]);

  // main search handler function
  const searchHandler = async (search) => {
    setsearchQuery(search);

    setcursor(0);
    if (search.length < 2) {
      const history =
        localStorage.getItem("searchHistory") && JSON.parse(localStorage.getItem("searchHistory"));
      if (history) {
        setresult([...history]);
      }
    } else {
      setdetails(null);
      var output = [];
      let size = 7;
      if (selected === "Products") {
        output = await searchProducts(search, size, filters);
      } else if (selected === "Customers") {
        output = await searchCustomers(search.split("@")[0]);
      } else {
        size = 5;
        output = searchIndexes.filter((out) => {
          return out.name.includes(search);
        });
      }
      setresult(output.splice(0, size));
    }
  };

  const handleKeyDown = (e) => {
    if (e.code === "ArrowUp" && cursor > 0) {
      setcursor((prevState) => prevState - 1);
    } else if (e.code === "ArrowDown" && cursor < result.length - 1) {
      setcursor((prevState) => prevState + 1);
    } else if (e.code === "Enter") {
      routeHandler(result[cursor]);
    } else if (e.code === "ArrowLeft") {
      setdetails(null);
    }
  };

  const routeHandler = async (item) => {
    if (item.brand) {
      setdetails(item);
    } else if (item.email) {
      setdetails(await getCustomerOrders(item._id));
    } else {
      if (item.merchant) {
        sessionStorage.setItem("merchantselected", JSON.stringify(item.merchant));
        window.open(item.slug, "_self");
      } else {
        navigate(item.slug);
      }
      setisLookup(false);
      setsearchQuery("");
    }

    const history = localStorage.getItem("searchHistory");
    let filter = [];
    if (history) {
      filter = JSON.parse(history).splice(0, 5);
    }
    filter.unshift(item);
    localStorage.setItem("searchHistory", JSON.stringify(filter));
  };

  return (
    <>
      {isLookup && (
        <>
          <div
            style={{ zIndex: 100 }}
            className={`fixed bg-white shadow-2xl transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 md:h-[600px] md:w-5/6 h-full w-full z-50 rounded-lg overflow-hidden`}
          >
            {/* Search Bar */}
            <LookupSearch
              onKeyDown={handleKeyDown}
              onChange={(e) => searchHandler(e.target.value)}
              value={searchQuery}
              setisLookup={setisLookup}
              autoFocus
              ref={(inputRef) => {
                // constructs a new function on each render
                if (inputRef) {
                  inputRef.focus();
                }
              }}
            />
            {/* Body */}

            <div className="py-4 px-6" onKeyDown={handleKeyDown}>
              {details && typeof details === "object" && Object.keys(details).length > 0 ? (
                <div>
                  <div
                    onClick={() => setdetails(null)}
                    className="flex items-center mb-3.5 cursor-pointer"
                  >
                    <RiArrowLeftCircleFill size={20} />
                    <div className="ml-2">Back</div>
                  </div>
                  <LookupDetails details={details} />
                </div>
              ) : (
                <>
                  <div>{searchQuery?.length > 1 ? "Search Results" : "History"}</div>
                  <div>
                    {result?.length > 0 ? (
                      result?.map((item, i) => (
                        <div key={i}>
                          <LookupResultItem
                            routeHandler={routeHandler}
                            item={item}
                            active={cursor == i}
                          />
                        </div>
                      ))
                    ) : (
                      <div className="text-zinc-500">No Results</div>
                    )}
                  </div>
                </>
              )}

              {/* Filters */}
              <LookupFilters selected={selected} setfilters={setfilters} filters={filters} />

              {/* Search Triggers */}
              <div className="absolute bottom-4 max-w-lg overflow-x-auto left-0 flex items-center border-t border-solid border-gray-100 px-8 pt-2 w-full">
                <div className="text-zinc-700 mr-2 uppercase text-xs font-semibold">
                  Search Database
                </div>
                <div className="flex items-center">
                  <LookupSelect
                    onClick={() => setselected("Dashboard")}
                    selected={selected}
                    title="Dashboard"
                    active={"Dashboard" === selected}
                  />
                  <LookupSelect
                    onClick={() => setselected("Products")}
                    selected={selected}
                    title="Products"
                    active={"Products" === selected}
                  />
                  <LookupSelect
                    onClick={() => setselected("Customers")}
                    selected={selected}
                    title="Customers"
                    active={"Customers" === selected}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Overlay */}
          <div
            style={{ zIndex: 99 }}
            className="fixed top-0 left-0 w-screen h-screen bg-black/20"
            onClick={() => setisLookup(false)}
          ></div>
        </>
      )}
    </>
  );
};

export default Lookup;
